import React from "react";

const DrivingSchoolFooter = () => {
  return (
    <footer className="vendor-header vendor-footer border-top bg-white">
      <div className="container-fluid px-4 py-2 d-flex flex-column flex-md-row justify-content-between align-items-center">

        {/* LEFT */}
        <div className="text-muted small">
          © 2025{" "}
          <a
            href="/"
            className="fw-semibold text-decoration-none text-dark"
          >
            Asysta
          </a>
        </div>

        {/* RIGHT (optional space for future links) */}
        <div className="small text-muted d-none d-md-block">
          All rights reserved
        </div>

      </div>
    </footer>
  );
};

export default DrivingSchoolFooter;
